import { PlaceOrderParameter } from "@husky-hrc/Framework/Store/Data/PlaceOrder/PlaceOrderState";
import Constants from "@husky-hrc/Utilities/Constants";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<Partial<PlaceOrderParameter>>;

export const DispatchUpdatePlaceOrderParameter: HandlerType = props => {
    props.dispatch({
        type: Constants.Actions.UpdatePlaceOrderParameter,
        parameter: props.parameter,
    } as any);
};

export const chain = [DispatchUpdatePlaceOrderParameter];

const updatePlaceOrderParameter = createHandlerChainRunner(chain, "UpdatePlaceOrderParameter");
export default updatePlaceOrderParameter;
